export enum Frequency {
  IRREGULAR = 'Irregular',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  ANNUAL = 'Annual',
  BIANNUAL = 'Biannual',
  TRIANNUAL = 'Triannual',
  YEARLY = 'Yearly'
}
